<template>
  <div id="app">
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
    <div class="row">
      <div
        class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-4 col-md-offset-4"
      >
        <div class="login-panel panel panel-default">
          <img
            src="../assets/solucasa.png"
            alt="..."
            class="rounded mx-auto d-block"
            style="width: 100%; height: 120px;"
          />
          <br />
          <div class="panel-body">
            <div class="form-group">
              <input
                class="form-control"
                placeholder="Usuario"
                name="email"
                type="text"
                autofocus
                v-model="username"
              />
            </div>
            <div class="form-group">
              <input
                class="form-control"
                v-on:keyup.enter="login"
                placeholder="Contraseña"
                name="password"
                type="password"
                value
                v-model="password"
              />
            </div>
            <div
              style="display: flex; justify-content: center; margin-bottom: 15px;"
            >
              <div
                id="g-recaptcha"
                class="g-recaptcha"
                data-sitekey="6LfhpvUqAAAAAA57uvAtSuGYpCo-R-C4yJPWeR7e"
              ></div>
            </div>
            <button
              @click="login"
              class="btn btn-primary"
              style="width: 100%"
            >
              Ingresar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceApi from '../ServiceApi';
import Loading from 'vue-loading-overlay';
import WsSubscriptions from '../WsSubscriptions';

export default {
  name: 'login',
  components: {
    Loading,
  },
  data: () => ({
    username: '',
    password: '',
    loading: false,
    captchaVerified: false,
  }),
  created() {
    this.$router.push('/');
    // Define the verifyCaptcha function globally so reCAPTCHA can access it
    window.verifyCaptcha = this.verifyCaptcha;
  },
  mounted() {
    // Render the reCAPTCHA once the component is mounted
    this.renderReCaptcha();
  },
  methods: {
    onCancel() {},
    renderReCaptcha() {
      // Check if grecaptcha is loaded
      if (window.grecaptcha) {
        window.grecaptcha.render('g-recaptcha', {
          sitekey: '6LfhpvUqAAAAAA57uvAtSuGYpCo-R-C4yJPWeR7e',
          callback: this.verifyCaptcha,
          'expired-callback': this.resetCaptcha,
        });
      } else {
        // If not loaded yet, wait a bit and try again
        setTimeout(this.renderReCaptcha, 100);
      }
    },
    verifyCaptcha(response) {
      // This function will be called by reCAPTCHA when the user completes the challenge
      this.captchaVerified = !!response;
    },
    login() {
      if (!this.username) {
        this.$noty.error('El usuario es requerido');
      } else if (!this.password) {
        this.$noty.error('La Contraseña es requerida');
      } else if (!this.captchaVerified) {
        this.$noty.error('Por favor complete el captcha');
      } else {
        this.loading = true;
        let data = {
          usuario: this.username,
          password: this.password,
          recaptcha: this.getCaptchaResponse(),
        };
        ServiceApi.post('/login', data)
          .then(response => {
            this.loading = false;
            //console.log(response)
            let data = response.data;
            this.$noty.success(`Bienvenido ${this.username}`);
            if (data.status) {
              sessionStorage.setItem('token', data.data.token);
              this.$store.commit('SET_LAYOUT', 'dashboard');
              this.$store.commit('SET_LOGIN', true);
              this.$store.commit('SET_USUARIO', this.username);
              this.$store.commit(
                'SET_URL_IMAGE',
                response.data.data.token.url_imagen
              );
              this.$store.commit(
                'SET_USUARIO_ID',
                response.data.data.token.id
              );
              this.$store.commit(
                'SET_ALERTAS',
                response.data.data.alertas
              );
              this.$store.commit('SET_ROL', data.data.rol);
              this.$store.commit(
                'SET_PERMISOS_USER',
                data.data.token.permisos
              );
              this.$store.commit(
                'SET_TOPIC_SOCKET',
                `user:${response.data.data.token.id}`
              );
            }
          })
          .catch(err => {
            this.loading = false;
            this.$noty.error('Ocurrio un error en la autenticación');
            this.username = '';
            this.password = '';
            // Reset captcha
            this.resetCaptcha();
          });
      }
    },
    getCaptchaResponse() {
      // Get the response token from reCAPTCHA
      return window.grecaptcha && window.grecaptcha.getResponse();
    },
    resetCaptcha() {
      // Reset the reCAPTCHA
      if (window.grecaptcha) {
        window.grecaptcha.reset();
        this.captchaVerified = false;
      }
    },
  },
  beforeDestroy() {
    // Clean up global function when component is destroyed
    window.verifyCaptcha = null;
  },
};
</script>
